import React, { useState } from 'react';
import Button from './Button';
const ContactForm = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    linkedin: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    const {
      name,
      value
    } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    // Simulate form submission
    setTimeout(() => {
      setIsSubmitting(false);
      setSubmitted(true);
      setFormData({
        name: '',
        email: '',
        linkedin: '',
        message: ''
      });
      // Reset success message after 5 seconds
      setTimeout(() => {
        setSubmitted(false);
      }, 5000);
    }, 1000);
  };
  return <form onSubmit={handleSubmit} className="space-y-6" data-id="element-91">
      {submitted && <div className="bg-indigo-900/30 border-l-4 border-indigo-500 p-4 mb-6" data-id="element-92">
          <div className="flex" data-id="element-93">
            <div data-id="element-94">
              <p className="text-indigo-300 font-medium" data-id="element-95">
                Thanks for reaching out! I'll get back to you soon.
              </p>
            </div>
          </div>
        </div>}
      <div data-id="element-96">
        <label htmlFor="name" className="block text-sm font-medium text-gray-300" data-id="element-97">
          Name
        </label>
        <input type="text" id="name" name="name" value={formData.name} onChange={handleChange} required className="mt-1 block w-full rounded-md border-gray-700 bg-gray-700 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm text-white" data-id="element-98" />
      </div>
      <div data-id="element-99">
        <label htmlFor="email" className="block text-sm font-medium text-gray-300" data-id="element-100">
          Email
        </label>
        <input type="email" id="email" name="email" value={formData.email} onChange={handleChange} required className="mt-1 block w-full rounded-md border-gray-700 bg-gray-700 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm text-white" data-id="element-101" />
      </div>
      <div data-id="element-102">
        <label htmlFor="linkedin" className="block text-sm font-medium text-gray-300" data-id="element-103">
          LinkedIn Profile
        </label>
        <input type="url" id="linkedin" name="linkedin" value={formData.linkedin} onChange={handleChange} placeholder="https://linkedin.com/in/yourprofile" className="mt-1 block w-full rounded-md border-gray-700 bg-gray-700 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm text-white placeholder:text-gray-500" data-id="element-104" />
      </div>
      <div data-id="element-105">
        <label htmlFor="message" className="block text-sm font-medium text-gray-300" data-id="element-106">
          Message
        </label>
        <textarea id="message" name="message" rows={5} value={formData.message} onChange={handleChange} required className="mt-1 block w-full rounded-md border-gray-700 bg-gray-700 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm text-white" data-id="element-107"></textarea>
      </div>
      <div data-id="element-108">
        <Button type="submit" variant="primary" size="lg" className="w-full sm:w-auto" onClick={() => {}} data-id="element-109">
          {isSubmitting ? 'Sending...' : 'Submit'}
        </Button>
      </div>
    </form>;
};
export default ContactForm;